import { Box, Paper, Stack, useMediaQuery } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/system'
import COLORS from '../styles/colors'
import FooterSocialButtons from './FooterSocialButtons'
import PageContainer from './PageContainer'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import Link from 'next/link'

const Footer = () => {
  const router = useRouter()
  const isDanish = router.locale === 'da'
  const { t } = useTranslation('Footer')
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('lg'))

  if (router.pathname.includes('/reading-room')) {
    return null
  }

  return (
    <Paper
      component="footer"
      sx={{
        backgroundColor: COLORS.greyDark,
        borderRadius: isSmall ? '0px' : '4px',
      }}
    >
      <PageContainer disableGutters>
        <Box
          sx={{
            color: '#fff',
            paddingLeft: isSmall ? '16px' : '200px',
            paddingRight: isSmall ? '16px' : '350px',
            paddingY: '2rem',
            paddingBottom: isSmall ? '2rem' : '60px',
            paddingTop: isSmall ? '2rem' : '40px',
          }}
        >
          <Stack
            direction={isSmall ? 'column' : 'row'}
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Stack direction="column" spacing="20px" maxWidth="630px">
              <Typography component="h1" variant="footerTitle">
                {t('title')}
              </Typography>
              <Typography variant="inter_smallText">{t('section1')}</Typography>

              <Box>
                <Typography variant="inter_smallText">
                  {t('section2')}
                </Typography>
              </Box>
            </Stack>
            <Stack spacing="20px">
              <Typography variant="inter_smallText">
                {t('follow us online')}
              </Typography>
              <FooterSocialButtons />
              <Typography variant="inter_smallText">
                {t('support')}:{' '}
                <a
                  href="mailto:support@humanlibrary.org"
                  style={{ color: COLORS.orange }}
                >
                  support@humanlibrary.org
                </a>
              </Typography>
              {isDanish && (
                <Stack>
                  <Typography variant="inter_smallText">
                    {t('velux support')}
                  </Typography>
                  <Link
                    href="https://veluxfonden.dk/da"
                    passHref
                    style={{ cursor: 'pointer' }}
                  >
                    <Image
                      src="/velux_logo.png"
                      alt="Velux Logo"
                      width={202}
                      height={60}
                      objectFit="contain"
                      unoptimized={true}
                    />
                  </Link>
                </Stack>
              )}
            </Stack>
          </Stack>
        </Box>
      </PageContainer>
    </Paper>
  )
}

export default Footer
